var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivelinessBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 3.5,
    stroke: "#CECECE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.75H17V14.75M21 14.5V13M14 21.5C15.5 23 18.5 23 20 21.5M13 14.5V13M14.4 26C12.16 26 11.04 26 10.184 25.564C9.43139 25.1805 8.81949 24.5686 8.436 23.816C8 22.96 8 21.84 8 19.6M26 19.6C26 21.84 26 22.96 25.564 23.816C25.1805 24.5686 24.5686 25.1805 23.816 25.564C22.96 26 21.84 26 19.6 26M19.6 8C21.84 8 22.96 8 23.816 8.436C24.5686 8.81949 25.1805 9.43139 25.564 10.184C26 11.04 26 12.16 26 14.4M14.4 8C12.16 8 11.04 8 10.184 8.436C9.43139 8.81949 8.81949 9.43139 8.436 10.184C8 11.04 8 12.16 8 14.4",
    stroke: "#CECECE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivelinessBtn);
export default __webpack_public_path__ + "static/media/liveliness-btn.fb8f6c1e2604cf20ae7b7c9dd013c80b.svg";
export { ForwardRef as ReactComponent };